import { render, staticRenderFns } from "./VinculoUsuario.vue?vue&type=template&id=5ae2e48e"
import script from "./VinculoUsuario.vue?vue&type=script&lang=js"
export * from "./VinculoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports